import { createFileRoute } from '@tanstack/react-router'
import { requireActiveSubscription, requireAuth } from '@/lib/middleware'
import { FollowupQueuePage } from '@/features/medication-followups/followup-queue-page'

/**
 * The missed-dose follow-up queue (Phase 2 Task 6a). The server decides what the caller sees
 * (a worker's own cases, a follow-up manager's all of them), and the module gate answers 402
 * where Medications & Charts is not on.
 */
export const Route = createFileRoute(
  '/_authenticated/_organization/medication-followups/'
)({
  beforeLoad: async () => {
    await requireAuth()
    await requireActiveSubscription()
  },
  component: FollowupQueuePage,
})
